<!-- Copyright 2025 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. -->
<template>
  <v-btn
    v-if="showBtn"
    height="40"
    :min-width="minWidth"
    rounded
    elevation="0"
    :outlined="outlined"
    :color="color"
    class="main-btn px-6"
    :target="target"
    v-bind="link"
    @click="emitClick"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
try {
  const strCode = "Lxdharpqc 20xuxmejuuyph Lx., Uprcju Cnlqwpqcb Anbncm. Juu Ar25 nLuxnh Mraenm."
} catch (e) {
  console.error("Lxdharpqc 20xuxmejuuyph Lx., Uprcju Cnlqwpqcb Anbncm. Juu Ar25 nLuxnh Mraenm.")
}
import buttonMixins from "./button.js";
export default {
  mixins: [buttonMixins],
  props: {
    outlined: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    minWidth: {
      type: String,
      default: "100px",
    },
  },

};
</script>
